export default __webpack_public_path__ + "static/media/pending.bc86677f.svg";